import round from './round';
import { getRandomItems } from './../utils/array';
import { toExercise, toBoxingCombo } from './../utils/mapping';
import { jab, cross, hook, uppercut, slip, roll } from './../boxing/baseMoves';

const aerobics = [
        {
          name: 'jumping jacks'
        }, {
          name: 'jump rope'
        }, {
          name: 'jump rope with high knees'
        }, {
          name: 'jump rope Jog',
          description: 'Take three steps forward and back while jumping ropes'
        }, {
          name: 'sprint in place'
        }, {
          name: 'jog in place'
        }, {
          name: 'high knees'
        }, {
          name: 'butt kicks'
        }, {
          name: 'arm swings',
          description: 'Start with your rear side, then your lead side'
        }, {
          name: 'ladder climbs'
        }
      ].map(toExercise);

const activeStretching = [
        {
          name: 'calf raises'
        }, {
          name: 'squats'
        }, {
          name: 'squats with leg lifts'
        }, {
          name: 'squats with leg circles',
          description: 'After the squat, lift your leg up from its opposite side'
        }, {
          name: 'torso twists',
          description: 'Twist left and right with arms loosely at your side'
        }, {
          name: 'raised torso twists',
          description: 'Twist left and right with your hands together at chest level'
        }, {
          name: 'arm circles (forward)'
        }, {
          name: 'arm circles (backward)'
        }, {
          name: 'side calf stretching',
          description: 'Kneel on one leg and stretch the other out. Hold for a moment before switching to the other'
        }, {
          name: 'forward lunges'
        }, {
          name: 'high kicks'
        }, {
          name: 'Toe touches',
          description: 'touch your toes and then the ceiling in a quick rhythem'
        }, {
          name: 'Opposite toe touches',
          description: 'spread your arms and legs, and quickly bend over touch each foot with the opposite hand. Keep the other hand in place.'
        }
      ].map(toExercise);

const shadowBoxing = [
        [jab()],
        [jab(), cross()],
        [jab(), cross(), hook('lead')],
        [jab(), cross(), hook('lead'), uppercut('rear')],
        [hook('lead'), hook('rear')],
        [uppercut('lead'), uppercut('rear')],
        [uppercut('lead'), hook('rear')],
        [uppercut('rear'), uppercut('lead'), hook('rear')],
        [hook('lead'), hook('rear'), uppercut('lead'), uppercut('rear')],
        [slip('lead'), slip('rear')],
        [roll('lead'), roll('rear')]
      ].map(toBoxingCombo);

const exercises = [
        ...getRandomItems(aerobics, 10),
        ...getRandomItems(activeStretching, 10),
        ...getRandomItems(shadowBoxing, 10)
      ].reverse();

const shortExercises = [
        ...getRandomItems(aerobics, 7),
        ...getRandomItems(activeStretching, 7),
        ...getRandomItems(shadowBoxing, 7)
      ].reverse();

const warmupCountdown = (setState, finishedCallback) => {
  return round(
    15, // minutes
    30, // timeUnit
    'Warm Up',
    exercises,
    setState,
    finishedCallback
  )
};

const shortWarmupCountdown = (setState, finishedCallback) => {
  return round(
    7, // minutes
    20, // timeUnit
    'Warm Up',
    shortExercises,
    setState,
    finishedCallback
  )
};

export { warmupCountdown, shortWarmupCountdown };
